export default "__VITE_ASSET__CfdDNr7R__"